<div
  class=""
  ng-init="resizeSubChild()"
  [style.height.px]="divHeight"
  (window:resize)="onResize()"
  (window:onload)="onResize()"
>
  <form [formGroup]="AddSiteForm" (ngSubmit)="SaveSite()" id="AddSiteForm">
    <div class="position-reletivediv popup-inner-space">
      <div class="betweenheader">
        {{ lblSite }}
      </div>
      <div class="text-right flow-right">
        <img
          src="assets/images/close.svg"
          alt="..."
          class="img-fluid closeicon2 cursor-pointer"
          (click)="Close()"
        />
      </div>
    </div>
    <div class="main-errormsg" *ngIf="errorMsg">{{ errorMsg }}</div>
    <div
      class="company-table margin-top-20 tabel-scrolling"
      [style.height.px]="tableHeight"
    >
      <table class="table add-site-table add-site-border" id="add-site-table">
        <!-- <thead class="companytable">
					<tr>
						<th class="width3"></th>
						<th class="widht90">Site Name</th>
						<th class="width7"></th>
					</tr>
				</thead> -->
        <tbody class="details" formArrayName="AddSiteArray" id="AddSiteArray">
          <ng-container
            *ngFor="
              let lstsite of AddSiteForm['controls'].AddSiteArray['controls'];
              let siteIndex = index
            "
            formGroupName="{{ siteIndex }}"
          >
            <tr
              *ngIf="lstsite['controls'].Mode.value != 'Delete'"
              id="{{ 'lstsite' + siteIndex }}"
            >
              <!-- width3 -->
              <td
                class="padding-top-15 td-outer"
                style="vertical-align: top"
                id="{{ 'tdAdmindsiteSiteindex' + siteIndex }}"
              >
                ({{ siteIndex + 1 }})
              </td>
              <!-- width90  -->
              <td
                class="main-table-w td-outer"
                style="width: 100%"
                id="{{ 'tdAdmindsiteOuter' + siteIndex }}"
              >
                <table
                  width="100%"
                  id="{{ 'tableAdmindsitemain' + siteIndex }}"
                >
                  <td id="{{ 'tdAdmindsitemain' + siteIndex }}">
                    <input
                      formControlName="CompSiteName"
                      (focusout)="onFocusOutEvent($event)"
                      style="width: 94%; margin-left: 3%"
                      placeholder="Customer Name"
                      id="{{ 'CompSiteName' + siteIndex }}"
                      class="custom-input-tabel"
                      [readonly]="IsreadOnly"
                    />
                  </td>
                  <td
                    class="td-main3"
                    style="vertical-align: top; width: 100px"
                    *ngIf="RoleName == 'Admin'"
                    id="{{ 'tdAdmindsiteimg' + siteIndex }}"
                  >
                    <a
                      ><img
                        id="{{ 'btnaddsiteAdd' + siteIndex }}"
                        class="ursor-pointer comman-icon"
                        src="/assets/images/add-icon.svg"
                        alt="addd-icon"
                        (click)="AddPanel(siteIndex)"
                    /></a>
                    <a
                      ><img
                        id="{{ 'btnaddsiteDelete' + siteIndex }}"
                        class="cursor-pointer comman-icon delete-ic"
                        src="/assets/images/delete-icon.svg"
                        alt="add-icon"
                        (click)="DeleteSite(siteIndex)"
                    /></a>
                  </td>
                </table>

                <table
                  class=""
                  width="100%"
                  id="{{ 'tableAddsitecomptbl' + siteIndex }}"
                >
                  <thead
                    class="companytable"
                    id="{{ 'theadAddsitecomptbl' + siteIndex }}"
                  >
                    <tr></tr>
                  </thead>
                  <tbody
                    class="details"
                    formArrayName="ListPanelMasterBO"
                    id="{{ 'ListPanelMasterBO' + siteIndex }}"
                  >
                    <ng-container
                      *ngFor="
                        let lstpanel of lstsite['controls'].ListPanelMasterBO[
                          'controls'
                        ];
                        let panelIndex = index
                      "
                      formGroupName="{{ panelIndex }}"
                    >
                      <tr
                        *ngIf="lstpanel['controls'].Mode.value != 'Delete'"
                        id="{{ 'trlstpanel' + panelIndex }}"
                      >
                        <td
                          id="{{ 'tdnumAdmincompanylstpanel' + panelIndex }}"
                          class="padding-top-15 padding-top-15 td-outer"
                          style="vertical-align: top"
                        >
                          ({{ siteIndex + 1 }}.{{ panelIndex + 1 }})
                        </td>
                        <td id="{{ 'tdAddsitePanelName' + siteIndex }}">
                          <table
                            width="100%"
                            id="{{ 'tableAdmincompanypanelmain' + panelIndex }}"
                          >
                            <td
                              width="100%"
                              id="{{ 'tdAddsitetxtPanelName' + siteIndex }}"
                            >
                              <input
                                formControlName="PanelName"
                                (focusout)="onFocusOutEvent($event)"
                                placeholder="Location Name"
                                class="custom-input-tabel custom-input-tabel1"
                                [readonly]="IsreadOnly"
                                id="{{
                                  'tdAdmincompanyPanelName' + panelIndex
                                }}"
                                width="97%"
                              />
                            </td>
                            <td
                              id="{{ 'tdAdmincompanyimage' + panelIndex }}"
                              class="icon-td text-right"
                              style="vertical-align: top; width: 102px"
                              *ngIf="RoleName == 'Admin'"
                            >
                              <a
                                ><img
                                  id="{{ 'btnadminaddsiteadd' + panelIndex }}"
                                  class="ursor-pointer comman-icon"
                                  src="/assets/images/add-icon.svg"
                                  alt="addd-icon"
                                  (click)="AddDevice(siteIndex, panelIndex)"
                              /></a>
                              <a
                                ><img
                                  id="{{
                                    'btnadminaddsitedelete' + panelIndex
                                  }}"
                                  class="cursor-pointer comman-icon delete-ic"
                                  src="/assets/images/delete-icon.svg"
                                  alt="add-icon"
                                  (click)="DeletePanel(siteIndex, panelIndex)"
                              /></a>
                            </td>
                          </table>

                          <table
                            width="100%"
                            id="{{
                              'tableAdminListDevicetypeMasterBO' + panelIndex
                            }}"
                          >
                            <thead class="companytable">
                              <tr></tr>
                            </thead>
                            <tbody
                              class="details"
                              formArrayName="ListDevicetypeMasterBO"
                              id="{{ 'ListDevicetypeMasterBO' + panelIndex }}"
                            >
                              <ng-container
                                *ngFor="
                                  let lstdevice of lstpanel['controls']
                                    .ListDevicetypeMasterBO['controls'];
                                  let deviceIndex = index
                                "
                                formGroupName="{{ deviceIndex }}"
                              >
                                <tr
                                  *ngIf="
                                    lstdevice['controls'].Mode.value != 'Delete'
                                  "
                                >
                                  <td>
                                    <table width="100%">
                                      <td
                                        class="padding-top-15 padding-top-15 td-outer tr-space width3"
                                        width="100%"
                                        style="vertical-align: top"
                                        id="{{ 'trAdmincompany' + panelIndex }}"
                                      >
                                        ({{ siteIndex + 1 }}.{{
                                          panelIndex + 1
                                        }}.{{ deviceIndex + 1 }})
                                      </td>
                                      <td
                                        id="{{
                                          'tdadminaddsiteDeviceName' +
                                            panelIndex
                                        }}"
                                        class="width1-100"
                                      >
                                        <input
                                          id="{{
                                            'txtadminaddsiteDeviceName' +
                                              panelIndex
                                          }}"
                                          formControlName="DeviceName"
                                          placeholder=" Device Name"
                                          class="custom-input-tabel device-type input-device-data"
                                          [readonly]="IsreadOnly"
                                        />
                                        <table
                                          class="width11123"
                                          id="{{
                                            'tableaddsiteListEnergymeterMasterBO' +
                                              panelIndex
                                          }}"
                                        >
                                          <tbody
                                            class="details"
                                            formArrayName="ListEnergymeterMasterBO"
                                            id="{{
                                              'ListEnergymeterMasterBO' +
                                                siteIndex
                                            }}"
                                          >
                                            <ng-container
                                              *ngFor="
                                                let lstenergy of lstdevice[
                                                  'controls'
                                                ].ListEnergymeterMasterBO[
                                                  'controls'
                                                ];
                                                let energyIndex = index
                                              "
                                              formGroupName="{{ energyIndex }}"
                                            >
                                              <tr
                                                *ngIf="
                                                  lstenergy['controls'].Mode
                                                    .value != 'Delete'
                                                "
                                                id="{{
                                                  'trAdmincompanyListEnergymeterMasterBO' +
                                                    siteIndex
                                                }}"
                                              >
                                                <td
                                                  id="{{
                                                    'tdaddsiteListEnergymeterMasterBO' +
                                                      panelIndex
                                                  }}"
                                                >
                                                  <table
                                                    class="tble-categories"
                                                    id="{{
                                                      'tableAdmincompanyenergytable' +
                                                        siteIndex
                                                    }}"
                                                  >
                                                    <tr
                                                      id="{{
                                                        'trAdmincompanyenergytable' +
                                                          siteIndex
                                                      }}"
                                                    >
                                                      <td
                                                        class="padding-top-15 td-outer width5"
                                                        id="{{
                                                          'tdAdmincompanyenergytable' +
                                                            siteIndex
                                                        }}"
                                                      >
                                                        ({{ siteIndex + 1 }}.{{
                                                          panelIndex + 1
                                                        }}.{{
                                                          deviceIndex + 1
                                                        }}.{{
                                                          energyIndex + 1
                                                        }})
                                                      </td>
                                                      <td
                                                        class="td-w"
                                                        id="{{
                                                          'tdAdmincompanyEnergymeterID' +
                                                            siteIndex
                                                        }}"
                                                        style="width: 15%"
                                                      >
                                                        <input
                                                          formControlName="EnergymeterID"
                                                          (focusout)="
                                                            onFocusOutEvent(
                                                              $event
                                                            )
                                                          "
                                                          placeholder="Meter ID"
                                                          class="custom-input-tabel meter-id border-remove"
                                                          [readonly]="
                                                            IsreadOnly
                                                          "
                                                          id="{{
                                                            'txtadminaddsiteEnergymeterID' +
                                                              siteIndex
                                                          }}"
                                                        />
                                                      </td>
                                                      <td
                                                        class=""
                                                        style="width: 120px"
                                                        id="{{
                                                          'tdAdmincompanyDeviceTypeId' +
                                                            siteIndex
                                                        }}"
                                                      >
                                                        <div
                                                          class="fxg-field fxg-field2 select-main"
                                                        >
                                                          <mat-form-field
                                                            style="
                                                              display: block;
                                                            "
                                                            title="Device Type"
                                                          >
                                                            <mat-select
                                                              [disabled]="
                                                                IsreadOnly
                                                              "
                                                              class="select-device brder-remove"
                                                              formControlName="DeviceTypeId"
                                                              (selectionChange)="
                                                                OnChangeDeviceType(
                                                                  $event,
                                                                  siteIndex,
                                                                  panelIndex,
                                                                  deviceIndex,
                                                                  energyIndex
                                                                )
                                                              "
                                                            >
                                                              <mat-option
                                                                value=""
                                                              >
                                                                (Select Device
                                                                Type)
                                                              </mat-option>
                                                              <mat-option
                                                                MatFormFieldControl="DeviceTypeId"
                                                                *ngFor="
                                                                  let lstdevicetype of DeviceTypeList
                                                                "
                                                                [value]="
                                                                  lstdevicetype.CodeValue
                                                                "
                                                              >
                                                                {{
                                                                  lstdevicetype.CodeDisplayText
                                                                }}
                                                              </mat-option>
                                                            </mat-select>
                                                          </mat-form-field>
                                                        </div>
                                                      </td>
                                                      <td
                                                        class="width15 pr-0"
                                                        id="{{
                                                          'tdAdmincompanyValidToDate' +
                                                            siteIndex
                                                        }}"
                                                      >
                                                        <mat-form-field
                                                          id="ValidToDate"
                                                          class="select-data date-picker-addsite"
                                                        >
                                                          <input
                                                            [disabled]="
                                                              IsreadOnly
                                                            "
                                                            formControlName="ValidToDate"
                                                            id="{{
                                                              'dteaddsiteValidToDate' +
                                                                siteIndex
                                                            }}"
                                                            name="ValidToDate"
                                                            (click)="
                                                              picker.open()
                                                            "
                                                            [min]="minDate"
                                                            matInput
                                                            [matDatepicker]="
                                                              picker
                                                            "
                                                            placeholder="Valid To"
                                                          />
                                                          <mat-datepicker-toggle
                                                            matSuffix
                                                            [for]="picker"
                                                          >
                                                          </mat-datepicker-toggle>
                                                          <mat-datepicker
                                                            #picker
                                                          >
                                                          </mat-datepicker>
                                                        </mat-form-field>
                                                      </td>
                                                      <td
                                                        class="Description"
                                                        id="{{
                                                          'tdAdmincompanyEnergymeterDesc' +
                                                            siteIndex
                                                        }}"
                                                        style="width: 15%"
                                                      >
                                                        <input
                                                          id="{{
                                                            'txtaddsiteEnergymeterDesc' +
                                                              siteIndex
                                                          }}"
                                                          [readonly]="
                                                            IsreadOnly
                                                          "
                                                          formControlName="EnergymeterDesc"
                                                          placeholder="Description"
                                                          class="custom-input-tabel border-remove"
                                                        />
                                                      </td>
                                                      <td
                                                        class="vertical-td34"
                                                        [disabled]="IsreadOnly"
                                                        id="{{
                                                          'tdAdmincompanychkEnergymeterDesc' +
                                                            siteIndex
                                                        }}"
                                                      >
                                                        <input
                                                          class="inputcheckbox"
                                                          type="checkbox"
                                                          formControlName="IsDisplay"
                                                          id="{{
                                                            'chckaddsiteEnergymeterDesc' +
                                                              siteIndex
                                                          }}"
                                                        />
                                                        &nbsp;<span
                                                          >IsDisplay</span
                                                        >
                                                      </td>
                                                      <!-- <td style="width: 100px;"
																							class="vertical-td">
																							<a (click)="
                                                                  OpenSetParamPopup(
                                                                  siteIndex,
                                                                  panelIndex,
                                                                  deviceIndex,
                                                                  energyIndex
                                                                  )
                                                                  " class="cursor-pointer config-b1">{{lblparameter}}</a>
																						</td> -->
                                                      <td
                                                        class="config"
                                                        style="width: 100px"
                                                        id="{{
                                                          'tdAdmincompanyConfiguration' +
                                                            siteIndex
                                                        }}"
                                                      >
                                                        <a
                                                          (click)="
                                                            OnConfigRegister(
                                                              siteIndex,
                                                              panelIndex,
                                                              deviceIndex,
                                                              energyIndex
                                                            )
                                                          "
                                                          class="cursor-pointer config-b1"
                                                          id="{{
                                                            'btnaddsiteConfiguration' +
                                                              siteIndex
                                                          }}"
                                                          >Configuration</a
                                                        >
                                                      </td>
                                                    </tr>
                                                  </table>
                                                </td>
                                                <td
                                                  class="td-main"
                                                  *ngIf="RoleName == 'Admin'"
                                                  id="{{
                                                    'tdAdmincompanyEngeryimage' +
                                                      siteIndex
                                                  }}"
                                                >
                                                  <a style="width: 15px"
                                                    ><img
                                                      id="{{
                                                        'btnaddsiteaddicon' +
                                                          siteIndex
                                                      }}"
                                                      class="ursor-pointer comman-icon"
                                                      src="/assets/images/add-icon.svg"
                                                      alt="addd-icon"
                                                      alt="addd-icon"
                                                      style="opacity: 0"
                                                  /></a>
                                                  <a style="width: 24px"
                                                    ><img
                                                      id="{{
                                                        'btnaddsitedeleteicon' +
                                                          siteIndex
                                                      }}"
                                                      class="cursor-pointer comman-icon delete-ic"
                                                      src="/assets/images/delete-icon.svg"
                                                      alt="add-icon"
                                                      (click)="
                                                        DeleteEnergyMeter(
                                                          siteIndex,
                                                          panelIndex,
                                                          deviceIndex,
                                                          energyIndex
                                                        )
                                                      "
                                                  /></a>
                                                </td>
                                              </tr>
                                            </ng-container>
                                          </tbody>
                                        </table>
                                      </td>
                                      <td
                                        class="config"
                                        style="width: 930px"
                                        id="{{
                                          'tdAdmincompanyaddsiteConfiguration' +
                                            siteIndex
                                        }}"
                                      >
                                        <a
                                          (click)="
                                            OnConfig(
                                              siteIndex,
                                              panelIndex,
                                              deviceIndex
                                            )
                                          "
                                          class="cursor-pointer config-b1"
                                          id="{{
                                            'btnaddsiteConfiguration' +
                                              siteIndex
                                          }}"
                                          >Configuration
                                        </a>
                                      </td>
                                    </table>
                                  </td>

                                  <td
                                    class="td-main"
                                    style="vertical-align: top; width: 102px"
                                    *ngIf="RoleName == 'Admin'"
                                    id="{{
                                      'tdAdmincompanyaddsiteicons' + siteIndex
                                    }}"
                                  >
                                    <a
                                      ><img
                                        class="ursor-pointer comman-icon"
                                        id="{{
                                          'btnaddsiteaddicon' + siteIndex
                                        }}"
                                        src="/assets/images/add-icon.svg"
                                        alt="addd-icon"
                                        alt="addd-icon"
                                        (click)="
                                          AddEnergyMeter(
                                            siteIndex,
                                            panelIndex,
                                            deviceIndex
                                          )
                                        "
                                    /></a>
                                    <a
                                      ><img
                                        class="cursor-pointer comman-icon delete-ic"
                                        id="{{
                                          'btnaddsitedeleteicon' + siteIndex
                                        }}"
                                        src="/assets/images/delete-icon.svg"
                                        alt="add-icon"
                                        (click)="
                                          DeleteDeviceType(
                                            siteIndex,
                                            panelIndex,
                                            deviceIndex
                                          )
                                        "
                                    /></a>
                                  </td>
                                </tr>
                              </ng-container>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </td>
              <!-- width7 -->
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
    <div class="add-site-space">
      <div class="float-left mt-3">
        <button
          type="button"
          id="AddSite"
          class="btncommon btn-orange btn-orange-add"
          (click)="AddSite()"
          *ngIf="RoleName == 'Admin'"
        >
          Add
        </button>
      </div>
      <div
        class="margin-top-7 mt-3 float-btn-comman"
        *ngIf="RoleName == 'Admin'"
      >
        <button id="btnAddsiteSave" class="btncommon" type="submit">
          Save
        </button>
        <button
          id="btnAddsitecancel"
          class="btncommon btn-border-add-company ml-24"
          (click)="OnCancel()"
        >
          Cancel
        </button>
      </div>
    </div>
  </form>
</div>
